import { euro } from "@/lib/format";

const Row = ({ label, value, testid, minus }) => (
  <div className="flex items-baseline justify-between gap-3 text-sm">
    <span className="text-muted-foreground">{minus ? "− " : ""}{label}</span>
    <span className="font-semibold tabular-nums" data-testid={testid}>{euro(value)}</span>
  </div>
);

// Conto del cantiere: importo dei lavori meno manodopera e spese = guadagno.
export const BilancioCantiere = ({ c }) => {
  const g = c.guadagno;
  return (
    <div className="rounded-xl border border-border bg-secondary/30 p-3 grid sm:grid-cols-2 gap-x-6 gap-y-1.5" data-testid="cantiere-balance">
      <div className="space-y-1">
        {c.importo_lavori ? <Row label="Importo lavori" value={c.importo_lavori} testid="cantiere-balance-amount" /> : null}
        <Row label="Manodopera" value={c.costo_manodopera} minus={!!c.importo_lavori} testid="cantiere-balance-labour" />
        <Row label="Spese del cantiere" value={c.totale_spese} minus={!!c.importo_lavori} testid="cantiere-balance-expenses" />
      </div>
      <div className="flex flex-col justify-center sm:items-end border-t sm:border-t-0 sm:border-l border-border pt-2 sm:pt-0 sm:pl-6">
        {g != null ? (
          <>
            <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Guadagno</div>
            <div className={`font-heading text-2xl font-extrabold tabular-nums ${g < 0 ? "text-destructive" : "text-emerald-600 dark:text-emerald-400"}`} data-testid="cantiere-balance-profit">{euro(g)}</div>
            <div className="text-xs text-muted-foreground" data-testid="cantiere-balance-margin">{Number(c.margine).toLocaleString("it-IT")}% dell'importo · costo totale {euro(c.costo_totale)}</div>
          </>
        ) : (
          <>
            <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Costo totale</div>
            <div className="font-heading text-2xl font-extrabold tabular-nums" data-testid="cantiere-balance-total-cost">{euro(c.costo_totale)}</div>
            <div className="text-xs text-muted-foreground">Inserisci l'importo dei lavori (Modifica) per vedere il guadagno.</div>
          </>
        )}
      </div>
    </div>
  );
};

export default BilancioCantiere;
